/**
 * Client mirror of the server display-name priority (server/src/lib/display-name.ts).
 *
 * core.retailer_license.display_name is the precomputed canonical value; this
 * helper is the UI fallback for when display_name is stale or absent, and it
 * guarantees the literal DCC sentinel "Data Not Available" never renders as a name.
 */

export const DBA_DNA_SENTINEL = "Data Not Available";

export function normalizeDbaName(dba: string | null | undefined): string | null {
  if (!dba) return null;
  const t = dba.trim();
  if (!t) return null;
  if (t.toLowerCase() === DBA_DNA_SENTINEL.toLowerCase()) return null;
  return t;
}

/**
 * UI display name: precomputed display_name (if present) > DBA (non-DNA) > Legal.
 * Mirrors the server priority so the UI degrades gracefully when display_name
 * hasn't been recomputed yet.
 */
export function displayLicenseName(
  displayName: string | null | undefined,
  dbaName: string | null | undefined,
  legalName: string | null | undefined
): string | null {
  const d = displayName?.trim();
  if (d) return d;
  const dba = normalizeDbaName(dbaName);
  if (dba) return dba;
  const legal = legalName?.trim();
  if (legal) return legal;
  return null;
}
